// eslint-disable-next-line jira/import/no-restricted-import, camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { formSubmitEmbedEntrypoint } from '@jira/spa-apps__software-form-submit-embed/src/formSubmitEmbedEntrypoint.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareFormSubmitEmbedRoute } from '@jira/router-routes__software-form-submit-embed-routes/src/softwareFormSubmitEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const formSubmitEmbedPageEntrypoint = createChromelessEntryPoint({
	main: formSubmitEmbedEntrypoint,
});

export const softwareFormSubmitEmbedRouteEntry: Route = createEntry(
	softwareFormSubmitEmbedRoute,
	() => ({
		group: 'software',
		ufoName: 'next-gen-form-submit-embed',
		layout: chromelessLayout,

		// eslint-disable-next-line camelcase
		resources: [DEPRECATED_DO_NOT_USE_projectDetailsResource],

		entryPoint: () => {
			return formSubmitEmbedPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
